<template>
  <div>
    <PageHeader title="Log Out"></PageHeader>
    <div>
      You are logged out. <router-link :to="{name: 'login'}">Log back in</router-link>
    </div>
  </div>
</template>

<script>
import PageHeader from './../../components/PageHeader';
import UserPool from "./../../plugins/UserPool";
import Socket from "./../../plugins/socket";

export default {
  name: 'logout',
  components: {
    PageHeader
  },
  methods: {
    goRedirect: function () {
      if(this.$route.query.redirect) {
         this.$router.push({name: 'login', query: {redirect: true}});
      }
    }
  },
  created () {
    var scope = this;
    this.$store.commit('setIsLoggedIn', false);
    this.$store.commit('setUserSub', null);
    this.$localStorage.remove("jwtToken");
    this.$localStorage.remove("userSub");
    this.$localStorage.remove("wallet");
    // if(this.$store.state.socket.isConnected){
    //   this.$store.dispatch('closeConnection');
    // }
    Socket.close();
    
    var user = UserPool.getCurrentUser();
    if(user) {
      user.getSession(() => {
        
      });
      user.globalSignOut({
        onSuccess: () => {
          scope.$store.commit('setWallet', null);
          scope.goRedirect();
        },
        onFailure: (err) => {
          console.log("onFailure: ", err);
          scope.goRedirect();
        }
      });
    } else {
      scope.goRedirect();
    }
  }
}
</script>